import styled from 'styled-components';

import { WithThemeProps, pxToRem } from '../../styles';


type ButtonStyledProps = {
	isActive: boolean;
} & WithThemeProps;

const Root = styled.div`
	position: relative;
	width: 100%;
	height: auto;
	background-color: transparent;
	padding: 20px 0;
`;

const ButtonStyled = styled.button`
	display: block;
	width: 100%;
	height: 34px;
	border: none;
	background-color: transparent;
	outline: none;
	font-family: 'Roboto';
	font-size: ${pxToRem(12)};
	font-weight: 400;
  line-height: 1.25;
	text-transform: uppercase;
	text-align: left;
	cursor: pointer;
	padding: 4px 22px 4px 16px;
	margin: 0;
	max-height: none;
	transition: background-color .2s ease-in-out, border-color .2s ease-in-out, font-size .2s ease-in-out;
	border-left: 6px solid transparent;

	${(p: ButtonStyledProps) => p.theme && `
		color: ${p.theme.palette.blackPrimary};

		&:hover {
			background-color: ${p.theme.palette.blackStealthy};
		}
	`}

	${(p: ButtonStyledProps) => p.isActive && `
		font-weight: 500;
		background-color: #fff;
		border-left: 6px solid ${p.theme.palette.accentPrimary};
		box-shadow: -3px 2px 2px 0 rgba(0, 0, 0, 0.08);

		&:hover {
			background-color: #fff;
		}
	`};

	@media (max-height: 400px) {
		font-size: ${pxToRem(10)};
	}

	@media (max-width: 700px) {
		font-size: ${pxToRem(10)};
	}
`;

export {
	Root,
	ButtonStyled,
};
